import Header from './components/Header';
import Hero from './components/Hero';
import FaqSection from './components/FaqSection';
import CarouselSection from './components/CarouselSection';
import TopicsSection from './components/TopicsSection';
import FeaturesSection from './components/FeaturesSection';
import IndexSection from './components/IndexSection';
import AppSection from './components/AppSection';
import CommentsSection from './components/CommentsSection';
import UpdatesSection from './components/UpdatesSection';
import AboutSection from './components/AboutSection';
import CardsSection from './components/CardsSection';
import MediaSection from './components/MediaSection';
import ContactSection from './components/ContactSection';
import RankingSection from './components/RankingSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <FaqSection />
        <CarouselSection />
        <TopicsSection />
        <FeaturesSection />
        <IndexSection />
        <AppSection />
        <CommentsSection />
        <UpdatesSection />
        <AboutSection />
        <CardsSection />
        <MediaSection />
        <ContactSection />
        <RankingSection />
      </main>
      <Footer />
    </>
  );
}